import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore
import React from "react";
import { Box } from "@material-ui/core";
import { FTLPageHeader, FTLPureTableComponent, FTLSearchField } from "ftl-uikit";
import { useGate, useStore } from "effector-react";
import { history, useShortcut } from "ftl-core";
import FTLCredentialListStore from "../../../../../domains/Credentials/CredentialList/store/FTLCredentialListStore";
const FTLCredentialListPage = ({}) => {
    useGate(FTLCredentialListStore.gate);
    const smartTableStore = useStore(FTLCredentialListStore.store);
    useShortcut("goBack", history.goBack);
    return (_jsxs(React.Fragment, { children: [_jsx(FTLPageHeader, { title: "\u0413\u043E\u0440\u043E\u0434\u0430", buttons: [
                    {
                        children: "Новый город",
                        onClick: () => history.push("/cities/new"),
                    },
                ] }, void 0), _jsx(Box, Object.assign({ display: "flex", pt: 6, overflow: "auto", flexShrink: 0 }, { children: _jsx(Box, Object.assign({ width: "200px", mr: 4, mb: 4, flexShrink: "0" }, { children: _jsx(FTLSearchField, { onChange: (value) => FTLCredentialListStore.onChangeSearchParamEvt({
                            key: "query",
                            value: value
                        }) }, void 0) }), void 0) }), void 0), _jsx(FTLPureTableComponent, Object.assign({}, smartTableStore, { onChangePage: FTLCredentialListStore.onChangeCurrentPageEvt, onChangeRowsPerPage: FTLCredentialListStore.onChangePageSizeEvt, onClickRow: (data => history.push(`/credential/${data.id}`)), onClickHeaderCell: (meta) => {
                    FTLCredentialListStore.onChangeSortEvt({ key: meta.id, value: meta.sortDirection == "asc" ? "desc" : "asc" });
                } }), void 0)] }, void 0));
};
export default FTLCredentialListPage;
//# sourceMappingURL=FTLCredentialListPage.js.map